var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 1.60254H5C3.9 1.60254 3.01 2.50254 3.01 3.60254L3 16.5325C3 17.2225 3.35 17.8325 3.88 18.1925L11.45 23.2325C11.79 23.4525 12.22 23.4525 12.56 23.2325L20.12 18.1925C20.65 17.8325 21 17.2225 21 16.5325V3.60254C21 2.50254 20.1 1.60254 19 1.60254ZM18.3 8.30254L10.71 15.8925C10.32 16.2825 9.69 16.2825 9.3 15.8925L5.71 12.3025C5.32 11.9125 5.32 11.2825 5.71 10.8925C6.1 10.5025 6.73 10.5025 7.12 10.8925L10 13.7725L16.88 6.89254C17.27 6.50254 17.9 6.50254 18.29 6.89254C18.68 7.28254 18.69 7.91254 18.3 8.30254Z",
    fill: "#050C33"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.4dc8331df78a23e7d2f350b35cc46496.svg";
export { ForwardRef as ReactComponent };